export const appName = [
  {
    value: "invoice_hero",
    label: "Invoice Hero",
  },
  {
    value: "acs",
    label: "ACS",
  },
  {
    value: "mcp",
    label: "MCP",
  },
  {
    value: "mckeckout",
    label: "mCheckout",
  }
];

export const invoice_hero_plan = [
  {
    value: "GOLD",
    label: "GOLD",
  },
  {
    value: "PLATINUM",
    label: "PLATINUM",
  },
  {
    value: "DIAMOND",
    label: "DIAMOND",
  }
];

export const invoice_hero_plan_interval = [
  {
    value: "monthly",
    label: "Monthly",
  },
  {
    value: "yearly",
    label: "Yearly",
  }
];

export const acs_plan_interval = [
  {
    value: "monthly",
    label: "Monthly",
  }
];

export const mcp_plan_interval = [
  {
    value: "monthly",
    label: "Monthly",
  }
];

export const mcheckout_plan_interval = [
  {
    value: "monthly",
    label: "Monthly",
  }
];

export const acs_price = "9.95";
export const acs_trialDays = "15";

export const mcp_price = "29";
export const mcp_trialDays = "15";

export const mcheckout_price = "9.95";
export const mcheckout_trialDays = "14";